(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    class Audio {
        constructor() {
            // global class identifier
            this.class = {
                audioWrapper: '.audio_wrapper',
                audioText: '.js__audio-text',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Two Click solution for YouTube Audio - Background-Image
         */
        audioPlaceholder() {
            if (document.querySelectorAll(this.class.audioWrapper).length > 0) {
                document.querySelectorAll(this.class.audioWrapper).forEach((wrapper) => {
                    wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                        const trigger = e.currentTarget.parentElement;
                        trigger.closest('.audio-module').querySelector(this.class.audioText).classList.add('d-none');
                        trigger.classList.add('d-none');
                        trigger.nextElementSibling.classList.add('d-block');
                        trigger.nextElementSibling.querySelector('iframe').setAttribute('src', trigger.dataset.source);
                    });
                });
            }
        }

        /**
         * Initialize Audio functions
         */
        init() {
            this.audioPlaceholder();
        }
    }

    new Audio();

    class Breadcrumbs {
        constructor() {
            // global class identifier
            this.class = {
                lorem: '.js-lorem',
                breadcrumb: '.js__breadcrumb',
                breadcrumbButton: '.js__breadcrumb-btn',
                breadcrumbCurrentItem: '.js__breadcrumb-current-item',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Adding event handler
         */
        addBreadcrumbEventHandler() {
            const breadcrumbButton = document.querySelector(this.class.breadcrumbButton);

            if (breadcrumbButton) {
                // Register Eventhandler
                breadcrumbButton.addEventListener('click', (e) => this.handleBreadcrumbBehavior(e));
            }
        }

        /**
         * Toggle visibility of current breadcrumb item
         */
        handleBreadcrumbBehavior(e) {
            const breadcrumb = document.querySelector(this.class.breadcrumb);
            let firstElement = {};
            const lastElement = document.querySelector(this.class.breadcrumbCurrentItem);

            // Toggle button
            e.currentTarget.classList.toggle('d-none');

            // Add startpage eventlistener
            if (window.getComputedStyle(e.currentTarget).visibility !== 'hidden') {
                firstElement = breadcrumb.querySelector('.breadcrumb-item').firstChild;
                firstElement.addEventListener('click', (e) => this.showInitialState(e));
            }

            // Change flex direction
            if (breadcrumb && breadcrumb.classList.contains('collapsed')) {
                breadcrumb.classList.remove('collapsed');
            } else {
                breadcrumb.classList.add('collapsed');
            }

            // Toggle last breadcrumb item
            if (lastElement && lastElement.classList.contains('hidden')) {
                lastElement.classList.remove('hidden');
                lastElement.classList.remove('d-none');
            } else {
                lastElement.classList.add('hidden');
                lastElement.classList.add('d-none');
            }
        }

        /**
         * Reset breadcrumb to initial state
         */
        showInitialState(e) {
            e.preventDefault();

            const breadcrumb = document.querySelector(this.class.breadcrumb);
            const breadcrumbButton = document.querySelector(this.class.breadcrumbButton);

            // Call event
            breadcrumbButton.click();

            // Reset flex-direction to row
            if (breadcrumb && breadcrumb.classList.contains('collapsed')) {
                breadcrumb.classList.remove('collapsed');
            }

            // Enable startpage link default behavior
            e.currentTarget.removeEventListener('click', null);
        }

        /**
         * Initialize breadcrumb functions
         */
        init() {
            this.addBreadcrumbEventHandler();
        }
    }

    new Breadcrumbs();

    class Carousel {
        constructor() {
            this.class = {
                carousel: '.js-carousel',
                carouselItem: '.js-carousel-item',
                carouselControlNext: '.carousel-control-next',
                carouselControlPrev: '.carousel-control-prev',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Add keyboard controls for more accessibility
         */
        addKeyboardControlls(carousel) {
            carousel.forEach((carouselItem) => {
                carouselItem.addEventListener('keyup', (event) => {
                    if (event.defaultPrevented) {
                        return; // Should do nothing if the default action has been cancelled
                    }

                    let handled = false;
                    const key = event.key || event.code || event.keyCode;

                    if (key === 'ArrowRight' || key === 39) {
                        document.querySelector(this.class.carouselControlNext).click();
                        handled = true;
                    } else if (key === 'ArrowLeft' || key === 37) {
                        document.querySelector(this.class.carouselControlPrev).click();

                        handled = true;
                    }

                    if (handled) {
                        // Suppress "double action" if event handled
                        event.preventDefault();
                    }
                });
            });
        }

        /**
         * function to iterate through all carousel items
         * and set all elements on same max height
         */
        setEqualHeights(carouselEl) {
            function setHeight(el, val) {
                if (typeof val === 'function') val = val();
                if (typeof val === 'string') el.style.height = val;
                else el.style.height = `${val}px`;
            }

            let currentTallest = 0;
            const elements = [];
            let currentDiv;

            carouselEl.querySelectorAll(this.class.carouselItem).forEach((el, index) => {
                el.style.height = 'auto';
                // we need to activate all carousel items to get the height of the element
                el.classList.add('active');
                elements.push(el);
                currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', '')))
                    ? (parseFloat(getComputedStyle(el, null).height.replace('px', '')))
                    : (currentTallest);
                for (currentDiv = 0; currentDiv < elements.length; currentDiv += 1) {
                    setHeight(elements[currentDiv], currentTallest);
                }
                if (index !== 0) {
                    // hide all items but first one
                    el.classList.remove('active');
                }
            });
        }

        init() {
            const carousel = document.querySelectorAll(this.class.carousel);
            if (carousel.length > 0) {
                this.addKeyboardControlls(carousel);

                // iterates through all carousel elements
                carousel.forEach((carouselEl) => {
                    window.addEventListener('load', () => {
                        this.setEqualHeights(carouselEl);
                    });

                    window.addEventListener('resize', () => {
                        setTimeout(() => {
                            this.setEqualHeights(carouselEl);
                        });
                    });

                    // mobile devices rotation
                    window.addEventListener('orientationchange', () => {
                        setTimeout(() => {
                            this.setEqualHeights(carouselEl);
                        });
                    });
                });
            }
        }
    }

    new Carousel();

    class Forms {
        constructor() {
            // global class identifier
            this.class = {
                needsValidation: '.needs-validation',
                offcanvasInput: '.js__offcanvas__solr-suggest',
                modalInput: '.js__modal__solr-suggest',
                newsletterSubscriptionFormField: 'input.subscription-email-prefill',
                newsletterSubscriptionFormFieldError: 'input.subscription-email-validation-error',
                searchItem: '.js__search-item',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Handle form validations.
         * On any validation error, set "was-validated" class to form
         */
        handleFormValidations() {
            const forms = document.querySelectorAll(this.class.needsValidation);

            if (!forms.length > 0) {
                return;
            }

            // iterate through elements in each form and listen to "invalid" event
            forms.forEach((form) => {
                form.querySelectorAll('select, textarea, input').forEach((formelement) => {
                    formelement.addEventListener('invalid', (e) => {
                        if (!form.classList.contains('was-validated')) {
                            form.classList.add('was-validated');
                            form.classList.remove('needs-validation');
                            e.currentTarget.closest('.form-group').classList.remove('is-invalid');
                        }
                        e.currentTarget.closest('.form-group').classList.add('is-invalid');
                    });
                });
            });
        }

        /**
         * Set focus on search input
         */
        focusSearchInput() {
            const offcanvasInput = document.querySelector(this.class.offcanvasInput);
            const modalInput = document.querySelector(this.class.modalInput);
            const searchItem = document.querySelector(this.class.searchItem);

            // set autofocus offcanvas input only when search icon is clicked
            if (offcanvasInput && searchItem) {
                searchItem.addEventListener('click', () => {
                    document.querySelector('#offcanvas').addEventListener('shown.bs.offcanvas', function setFocus(e) {
                        offcanvasInput.focus();
                        // removes the event listener after focus
                        e.currentTarget.removeEventListener('shown.bs.offcanvas', setFocus);
                    });
                });
            }

            if (modalInput) {
                document.querySelector('#searchModal').addEventListener('shown.bs.modal', () => {
                    modalInput.focus();
                });
            }

            // removes focus when offcanvas is closed
            document.querySelector('#offcanvas').addEventListener('hidden.bs.offcanvas', () => {
                offcanvasInput.blur();
            });
        }

        /**
         * Prefill Email field from url in newsletter subscription form
         */
        prefillNewsletterSubscriptionForm() {
            const field = document.querySelector(this.class.newsletterSubscriptionFormField);
            const getParameter = 'email';

            if (field) {
                let getValue = '';
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                getValue = urlParams.get(getParameter);
                if (getValue) {
                    field.value = getValue;
                }
            }
        }

        /**
         * Display error msg in newsletter subscription form
         */
        errorNewsletterSubscriptionForm() {
            const field = document.querySelector(this.class.newsletterSubscriptionFormFieldError);

            if (field) {
                field.nextElementSibling.style.display = 'block';
            }
        }

        init() {
            this.handleFormValidations();
            this.focusSearchInput();
            this.prefillNewsletterSubscriptionForm();
            this.errorNewsletterSubscriptionForm();
        }
    }

    new Forms();

    class LeafletCustom {
        constructor() {
            // add global class identifier
            this.class = {
                rlpmaps: '.js-rlpmaps-map',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        // eslint-disable-next-line class-methods-use-this
        rlpMaps(url, layers, format, attribution, uid, mapObject, settingsMap1) {
            const settingsMap = settingsMap1;
            settingsMap.run = () => {
                settingsMap.zoom = mapObject.dataset.zoom;

                if (Number.isNaN(parseInt(settingsMap.zoom, 10))) {
                    settingsMap.zoom = 7;
                }

                settingsMap.autoFit = mapObject.dataset.autofit;
                settingsMap.focusFirst = mapObject.dataset.focusFirst;

                const records = document.getElementById(`rlpmaps__records__${uid}`);

                if (parseInt(settingsMap.focusFirst, 10) === 1) {
                    settingsMap.center = [
                        parseFloat(records.childNodes[0].getAttribute('data-lat')),
                        parseFloat(records.childNodes[0].getAttribute('data-lng')),
                    ];
                }

                settingsMap.map = L.map(mapObject.getAttribute('id')).setView(settingsMap.center, settingsMap.zoom);
                L.tileLayer
                    .wms(url, {
                        layers,
                        format,
                        transparent: true,
                        attribution,
                    })
                    .addTo(settingsMap.map);

                const rlpIcon = L.icon({
                    iconUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Images/RLP_marker_Icon.png',
                    iconRetinaUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Images/RLP_marker_Icon_2x.png',
                    shadowUrl: '/typo3conf/ext/rlp_maps/Resources/Public/Css/images/marker-shadow.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    tooltipAnchor: [16, -28],
                    shadowSize: [41, 41],
                });
                for (let i = 0; i < records.childNodes.length; i += 1) {
                    const item = records.childNodes[i];
                    const dataId = item.getAttribute('data-id');

                    const marker = L.marker([item.getAttribute('data-lat'), item.getAttribute('data-lng')], { icon: rlpIcon })
                        .addTo(settingsMap.map)
                        .bindPopup(document.getElementById(`rlpmaps__record-${dataId}`).innerHTML);
                    settingsMap.markers.push(marker);
                }
                const group = new L.featureGroup(settingsMap.markers); // eslint-disable-line  new-cap
                if (parseInt(settingsMap.autoFit, 10) === 1) {
                    settingsMap.map.fitBounds(group.getBounds());
                }
            };

            settingsMap.openMarker = (markerId) => {
                settingsMap.markers[markerId].openPopup();
            };

            return settingsMap;
        }

        /**
         * initialize functions
         */
        init() {
            document.querySelectorAll(this.class.rlpmaps).forEach((map) => {
                let url = '';
                let attribution = '';
                const dataMapId = map.dataset.mapId;
                let layers = '';
                let format = '';
                const serviceUrl = 'https://maps.rlp.de/services/services-rlp.json';
                const dataUid = map.dataset.uid;
                // const map = this;
                const settingsMap = {
                    map: null,
                    markers: [],
                    center: [49.957, 7.152],
                    zoom: null,
                    focusFirst: 0,
                    autoFit: 0,
                };
                const self = this;
                const xhr = new XMLHttpRequest();
                xhr.open('POST', serviceUrl);
                xhr.addEventListener('load', () => {
                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        if (data.error) ; else {
                            for (let i = 0; i < data.length; i += 1) {
                                if (data[i].id === dataMapId) {
                                    attribution = data[i].layerAttribution;
                                    url = data[i].url;
                                    layers = data[i].layers;
                                    format = data[i].format;
                                }
                            }

                            // eslint-disable-next-line max-len
                            const rlpMapsMapInstance = self.rlpMaps(url, layers, format, attribution, dataUid, map, settingsMap);
                            rlpMapsMapInstance.run();
                            document.addEventListener('click', (event) => {
                                if (!event.target.matches('.rlpmaps__markerlink')) {
                                    return;
                                }
                                event.preventDefault();
                                const element = event.target;
                                rlpMapsMapInstance.openMarker(parseInt(element.getAttribute('data-iteration-id'), 10));
                            }, false);
                        }
                    }
                });
                xhr.send();
            });
        }
    }

    new LeafletCustom();

    class SiteWideMessaging {
        constructor() {
            // add global class identifier
            this.class = {
                trigger: '.js__siteWideMessaging',
                delay: 1000 * 1.5,
                cookieName: 'siteWideMessaging',
                cookieValue: 1,
                closeButtonId: 'closeSiteWideMessaging',
                modalId: 'modalSiteWideMessaging',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            this.siteWideMessaging();
        }

        /**
         * run side wide messaging
         */
        siteWideMessaging() {
            if (document.querySelectorAll(this.class.trigger).length > 0) {
                document.getElementById(this.class.closeButtonId).addEventListener('click', () => {
                    this.setCookie();
                });

                const cookie = this.getCookie(this.class.cookieName);
                if (!cookie) {
                    setTimeout(() => {
                        this.openModal();
                    }, this.class.delay);
                }
            }
        }

        openModal() {
            // trigger bootstrap modal event
            const modal = new bootstrap.Modal(document.getElementById(this.class.modalId), {});
            modal.show();
        }

        setCookie() {
            document.cookie = `${this.class.cookieName}=${this.class.cookieValue}`;
        }

        // eslint-disable-next-line class-methods-use-this
        getCookie(cname) {
            const name = `${cname}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i += 1) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }

        // currently not in use
        deleteCookie() {
            document.cookie = `${this.class.cookieName}=;expires=Thu, 01 Jan 1970`;
        }
    }

    new SiteWideMessaging();

    class Video {
        constructor() {
            // global class identifier
            this.class = {
                videoWrapper: '.video_wrapper',
                carousel: '.carousel',
                videoText: '.js__video-text',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * Two Click solution for YouTube Video - Background-Image
         */
        videoPlaceholder() {
            const videoWrapper = document.querySelectorAll(this.class.videoWrapper);
            if (videoWrapper.length > 0) {
                videoWrapper.forEach((wrapper) => {
                    wrapper.querySelector('button[type="button"]').addEventListener('click', (e) => {
                        const trigger = e.currentTarget.parentElement;
                        trigger.closest('.video-module').querySelector(this.class.videoText).classList.add('d-none');
                        trigger.classList.add('d-none');
                        trigger.nextElementSibling.classList.add('d-block');
                        trigger.nextElementSibling.querySelector('iframe').setAttribute('src', `https://www.youtube-nocookie.com/embed/${trigger.dataset.source}?rel=0&controls=0&showinfo=0&autoplay=1`);
                    });
                });
            }
        }

        /**
         * Pause iframe videos on carousel slide
         */
        iframeVideoStopOnSlide() {
            const carousel = document.querySelectorAll(this.class.carousel);

            if (carousel.length > 0) {
                carousel.forEach((carouselItem) => {
                    carouselItem.addEventListener('slide.bs.carousel', () => {
                        document.querySelectorAll('.carousel-video').forEach((e) => {
                            if (e.currentTarget.closest('.carousel-item').classList.contains('active')) {
                                e.currentTarget.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                            }
                        });
                    });
                });
            }
        }

        init() {
            this.videoPlaceholder();
            this.iframeVideoStopOnSlide();
        }
    }

    new Video();

    class LightGalleryCustom {
        constructor() {
            // add global class identifier
            this.class = {
                lightGallery: '.lightgallery',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        /**
         * initialize functions
         */
        init() {
            const galleries = document.querySelectorAll(this.class.lightGallery);

            if (galleries.length > 0) {
                galleries.forEach((gallery) => {
                    const thumb = gallery.hasAttribute('data-enable-thumbs');
                    const imgDownload = gallery.hasAttribute('data-enable-download');
                    const countImg = gallery.querySelectorAll('.lightbox-item').length;
                    const enableDrag = countImg > 1;

                    const termsOfUseMarkup = document.querySelector('.js-lightgallery-termsofuse');

                    lightGallery(gallery, {
                        licenseKey: 'D6DCCE11-A9E44E57-A60D181A-DB8E015BD6DCCE11-A9E44E57-A60D181A-DB8E015B',
                        plugins: [lgThumbnail],
                        controls: true,
                        selector: 'a.lightbox-item',
                        thumbnail: thumb,
                        exThumbImage: 'data-external-thumb-image',
                        alignThumbnails: 'left',
                        download: imgDownload,
                        hideBarsDelay: 999999,
                        counter: false,
                        preload: 0,
                        closable: true,
                        enableDrag,
                        allowMediaOverlap: true,
                        toggleThumb: true,
                    });

                    gallery.addEventListener('lgBeforeOpen', () => {
                        const toolbar = document.querySelector('.lg-toolbar');
                        const toggleThumb = document.querySelector('.lg-toggle-thumb');
                        const components = document.querySelector('.lg-components');

                        // adds terms of use inside toolbar
                        toolbar.appendChild(termsOfUseMarkup);
                        toolbar.querySelector('.js-lightgallery-termsofuse').classList.remove('d-none');

                        // move toggle thumb button
                        components.appendChild(toggleThumb);
                    });

                    gallery.addEventListener('lgBeforeSlide', (event) => {
                        const { index } = event.detail;
                        const download = document.querySelector('.lg-download');
                        const lightboxItem = document.querySelectorAll('.lightbox-item')[index];
                        const filesize = document.querySelector('.lg-filesize');

                        // adds download label and size
                        if (!document.querySelector('.lg-download-wrapper')) {
                            const wrapper = document.createElement('div');
                            wrapper.classList.add('lg-download-wrapper');
                            download.parentNode.insertBefore(wrapper, download);
                            wrapper.appendChild(download);
                        }

                        // create new filesize markup if not exist, otherwise overwrite filesize
                        if (!filesize) {
                            download.insertAdjacentHTML('beforeend', `<div class="d-none d-sm-inline-block lb-dl-font">${lightboxItem.dataset.downloadlabel}<span class="lg-filesize ms-1">(${lightboxItem.dataset.filesize})</span></div>`);
                        } else {
                            filesize.innerHTML = `(${lightboxItem.dataset.filesize})`;
                        }
                    });
                });
            }
        }
    }

    new LightGalleryCustom();

}));
